// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4759) return "static/chunks/4759.ae4b084dd70a13e0.js";
	if (chunkId === 6967) return "static/chunks/6967.b49a415a355ccf74.js";
	if (chunkId === 3384) return "static/chunks/3384.9be0253e70d2300d.js";
	if (chunkId === 1822) return "static/chunks/1822.1a1417fc5400292e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"660":"1d67ef6a600dd45b","2199":"181ae187aba1ac87","5084":"4f4395c44f5994b8","5723":"65cd54a2f597d1da","5973":"d0695a3776e6e544","7480":"3fb0627e6e50318e","8280":"5b52f06665133575","9764":"500952bee45dc017"}[chunkId] + ".js";
};